const getStyles = () => {
    return {
        column: {
        },

        rectangle: {
        },

        row: {
        },

        square: {
        },
    };
};

export default getStyles;
